import { TSubscription } from 'src/interfaces/subscription';
import {
    AdvancedSVG,
    EssentialSVG,
    PremiumSVG,
    ProfessionalSVG,
} from '../assets';
import { TEmailMarketingPlan } from './types';

export const ESSENTIAL_EMAIL_MARKETING_PLAN: TSubscription = {
    name: 'Essential',
    total: 5000,
};

export const ADVANCED_EMAIL_MARKETING_PLAN: TSubscription = {
    name: 'Advanced',
    total: 10000,
};

export const PROFESSIONAL_EMAIL_MARKETING_PLAN: TSubscription = {
    name: 'Professional',
    total: 20000,
};

export const PREMIUM_EMAIL_MARKETING_PLAN: TSubscription = {
    name: 'Premium',
    total: 50000,
};

export const ALL_EMAIL_MARKETING_PLANS: TSubscription[] = [
    ESSENTIAL_EMAIL_MARKETING_PLAN,
    ADVANCED_EMAIL_MARKETING_PLAN,
    PROFESSIONAL_EMAIL_MARKETING_PLAN,
    PREMIUM_EMAIL_MARKETING_PLAN,
];

export const EMAIL_MARKETING_PLANS: TEmailMarketingPlan[] = [
    {
        name: ESSENTIAL_EMAIL_MARKETING_PLAN.name,
        Image: EssentialSVG,
        features: ['5k', 'Filter', 'UploadContacts', 'DesignCampaign', 'HTML'],
        prices: { dollars: 250, pesos: 4375, conversionRate: 17.5 },
        costPerEmail: 0.05,
        total: ESSENTIAL_EMAIL_MARKETING_PLAN.total,
    },
    {
        name: ADVANCED_EMAIL_MARKETING_PLAN.name,
        Image: AdvancedSVG,
        features: ['10k', 'Filter', 'UploadContacts', 'DesignCampaign', 'HTML'],
        prices: { dollars: 400, pesos: 7000, conversionRate: 17.5 },
        costPerEmail: 0.04,
        total: ADVANCED_EMAIL_MARKETING_PLAN.total,
    },
    {
        name: PROFESSIONAL_EMAIL_MARKETING_PLAN.name,
        Image: ProfessionalSVG,
        features: ['20k', 'Filter', 'UploadContacts', 'DesignCampaign', 'HTML'],
        prices: { dollars: 600, pesos: 10500, conversionRate: 17.5 },
        costPerEmail: 0.03,
        isRecommended: true,
        total: PROFESSIONAL_EMAIL_MARKETING_PLAN.total,
    },
    {
        name: PREMIUM_EMAIL_MARKETING_PLAN.name,
        Image: PremiumSVG,
        features: ['50k', 'Filter', 'UploadContacts', 'DesignCampaign', 'HTML'],
        prices: { dollars: 1000, pesos: 17500, conversionRate: 17.5 },
        costPerEmail: 0.02,
        total: PREMIUM_EMAIL_MARKETING_PLAN.total,
    },
];
